module.exports = __webpack_public_path__ + "img/not-purchased.d662b0ad.png";